import { Injectable } from '@angular/core';
import { HelpersService } from '../../core/helpers/helpers.service';
import { Observable } from 'rxjs/Observable';
import { ChannelItem } from './model/channel-item';
import * as is from 'is_js';
import { EpgItem, Program } from './model/epg-item';
import { BtvClientServicesService } from '../cms-btv-client-api';
import { ChannelP, ClientServicesService } from '../360-client-api';
import { AuthService } from '../../core/authentication/auth.service';
import { BaseDataService } from '../commons/base-data.service';
import { LiveRecord } from './model/live-recording';

@Injectable()
export class BtvDataRestService extends BaseDataService{
  readonly productID = 1;
  constructor(
    private restBtv: BtvClientServicesService,
    private restClient: ClientServicesService,
    private authService: AuthService,
    helpers: HelpersService,
  ) { 
    super(helpers);
  }

  startChannel(channelID: number): Observable<any> {
    return this.restBtv.startChannelUsingGET(channelID).map(response => {
      if (response.code == 200) {
        return true;
      }
      else {
        false;
      }
    })
  }

  stopChannel(channelID: number): Observable<any> {
    return this.restBtv.stopChannelUsingGET(channelID).map(response => {
      if (response.code == 200) {
        return true;
      }
      else {
        false;
      }
    })
  }
  
  getChannels(): Observable<ChannelP[]> {
    let channelGroupID: number = 1;
    return this.restBtv.getActiveChannelsOfChannelG(channelGroupID).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        // this.helpers.logger.error(response);
        return null;
      }
    })
  }


  getChannel(id: number | null): Observable<ChannelP> {
    return
    // return this.rest.getltv(id).map(response => {
    //   if (is.existy(response) && response.code == 200) {
    //     return response.data;
    //   }
    //   else {
    //     this.helpers.logger.error(response);
    //     return null;
    //   }
    // })
  }

  searchChannels(searchQuery: string | null): Observable<ChannelItem[]> {
    return
  }

  getChannelList(listID: any): Observable<any> {
    return
  }
  getChannelLists(): Observable<any[]> {
    return
    // return this.rest.getLtvGenresUsingGET().map(response => {
    //   if (is.existy(response) && response.code == 200) {
    //     return response.data;
    //   }
    //   else {
    //     return [];
    //   }
    // })
  }
  getRelatedChannels(contentID: string): Observable<ChannelItem[]> {
    return
  }

  getEpgDataByChannelId(channelID: number, date: string): Observable<Program[]> {
    return this.restBtv.getEpgData(channelID, date).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        // this.helpers.alert.error("epg data did not come. Problem !")
      }
    })
  }

  getDailyEpgs(day: string): Observable<EpgItem[]> {
    return this.restBtv.getDailyEpgs(day).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
      }
    })
  }

  getRecordsByChannel(channelID: number): Observable<LiveRecord[]> {
    return this.restBtv.getLiveRecordingsByChannel(channelID).map(response => {
      if (is.existy(response) && response.code == 200) {
        return response.data;
      }
      else {
        // this.helpers.logger.error(response);
        return null;
      }
    })
  }
 
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/btv/btv-data-rest.service.ts